import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const createSetupIntent = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    const response = await axios.post(
      `${API_URL}/shop/orders/create-setup-intent/`,
      {},
      config
    );
    return response.data;
  } catch (error) {
    // Handle or throw error
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Create setup intent error:", error.response);
      throw error;
    }
  }
};

export const createOrderPayment = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    const response = await axios.post(
      `${API_URL}/shop/orders/payment/`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    // Handle or throw error
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Create order error:", error.response);
      throw error;
    }
  }
};

export const getOrders = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    const response = await axios.get(`${API_URL}/shop/orders/`, config);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 500) {
      console.error("500 Internal Server Error");
      throw error;
    } else {
      console.error("Get orders error:", error.response);
      throw error;
    }
  }
};

// Product Review API functions
export const getProductReviews = async (productId) => {
  try {
    const response = await axios.get(
      `${API_URL}/shop/product/${productId}/reviews/`
    );
    return response.data;
  } catch (error) {
    console.error("Get reviews error:", error.response);
    throw error;
  }
};

export const createProductReview = async (productId, reviewData) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    const response = await axios.post(
      `${API_URL}/shop/product/${productId}/reviews/create/`,
      reviewData,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Create review error:", error.response);
    throw error;
  }
};

export const updateProductReview = async (productId, reviewData) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    const response = await axios.put(
      `${API_URL}/shop/product/${productId}/reviews/update/`,
      reviewData,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Update review error:", error.response);
    throw error;
  }
};

export const deleteProductReview = async (productId) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    };
    const response = await axios.delete(
      `${API_URL}/shop/product/${productId}/reviews/delete/`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Delete review error:", error.response);
    throw error;
  }
};
